import { AdminCrudPage, AdminCrudPageConfig } from '@/components/admin';

/**
 * Board #49. Three things were wrong with the old config, and only the first
 * one reached the user as the reported "Request failed with status code 404":
 *
 * 1. `AdminCrudPage` rendered Import/Export unconditionally, and
 *    `ledger.FiscalYearViewSet` has no such actions -- so `GET
 *    /ledger/fiscal-years/export/` fell through to the router's DETAIL
 *    pattern and became a lookup for a fiscal year with the primary key
 *    "export". Fixed once in the shared component: `hasImportExport` is now
 *    opt-in and this endpoint does not opt in.
 * 2. `ledger.FiscalYear` has a REQUIRED `broker` FK and this form had no
 *    broker input, so every create 400'd on a field the screen could not
 *    show. The backend now infers it for a broker-side caller; a country
 *    admin, who administers many brokers and is the only role routed here,
 *    picks it below.
 * 3. `is_active` is not a field on `FiscalYear`. The Status column rendered
 *    "Inactive" for every row regardless, the "Active" checkbox wrote a key
 *    DRF discards, and `hasActivate` offered a bulk Activate that PATCHed
 *    `{is_active}` -- ignored by the serializer -- and then reported "Items
 *    activated". The real field is `is_closed`.
 */
const config: AdminCrudPageConfig<{ id: string; [key: string]: unknown }> = {
  title: 'Fiscal Years',
  apiEndpoint: '/ledger/fiscal-years/',
  queryKey: 'fiscalYears',
  entityName: 'Fiscal Year',
  columns: [
    { key: 'name', label: 'Name' },
    { key: 'broker_name', label: 'Broker' },
    { key: 'start_date', label: 'Start Date' },
    { key: 'end_date', label: 'End Date' },
    { key: 'is_closed', label: 'Status', render: (v: unknown) => (v ? 'Closed' : 'Open') },
  ],
  formFields: [
    { name: 'name', label: 'Name', type: 'text', required: true },
    // `/brokers/` is the broker list (BrokerViewSet is registered at the
    // router root of apps.brokers.urls, so there is no `/brokers/brokers/`).
    // It is country-scoped server-side, so this offers exactly the brokers
    // the signed-in admin may write books for.
    { name: 'broker', label: 'Broker', type: 'select', apiEndpoint: '/brokers/', required: true, searchable: true },
    { name: 'start_date', label: 'Start Date', type: 'date', required: true },
    { name: 'end_date', label: 'End Date', type: 'date', required: true },
    { name: 'is_closed', label: 'Closed', type: 'boolean' },
  ],
  searchPlaceholder: 'Search fiscal years...',
};

export function FiscalYearsPage() {
  return <AdminCrudPage config={config} />;
}
